export const uniqueId = (prefix: string = 'id') =>
  `${prefix}_${Math.random().toFixed(10)}`;
